<app-header
  [(opened)]="sidenavOpened"
  [sidenav]="sidenavToggleEnable"
  [notificationList]="notificationList"
  [lastReadAt]="lastReadAt"
  (notificationListUpdated)="findNotificationList($event)"
  (loggedOut)="logout()"
></app-header>
<app-sidenav
  [opened]="!sidenavToggleEnable || sidenavOpened"
  [mode]="sidenavMode"
  [type]="sidenavType"
  [role]="sidenavRole"
  (closed)="sidenavOpened = false"
  (sidenavItemPushed)="refreshNotificationList()"
>
  <main id="matp-main" class="tw-px-10 tw-h-full tw-overflow-auto">
    <router-outlet />
  </main>
</app-sidenav>
